import styled from 'styled-components';
import {
  flexBoxCenter,
  justifyContentSpaceEvenly,
  layerDegHPA,
  layerHPA,
} from 'shared/styles/commonStyles';
import SetTempBox from '../temperatureBox/SetTempBox';

const WindFactorMain = () => {
  const smallBoxesTitles = [
    { title: 'low wind factor trigger', speed: '15-24 miles/h' },
    { title: 'med wind factor trigger', speed: '25-37 miles/h' },
    { title: 'high wind factor trigger', speed: '38-52 miles/h' },
    { title: 'extreme wind factor trigger', speed: '53-62miles/h' },
  ];

  return (
    <Wrapper>
      <TitleWrapper>
        <Title>wind factor trigger</Title>
      </TitleWrapper>
      <MainTempBox>
        {smallBoxesTitles.map(({ title, speed }, idx) => (
          <TempBoxWrapper key={idx}>
            <SetTempBox isWindFactor={true} title={title} windSpeed={speed} />
          </TempBoxWrapper>
        ))}
      </MainTempBox>
    </Wrapper>
  );
};

export default WindFactorMain;

const Wrapper = styled.section`
  height: 236px;
  width: 833px;


  border-radius: 5px;

  ${layerDegHPA}


  ${justifyContentSpaceEvenly}
  flex-direction: column;
`;

const TitleWrapper = styled.div`
  height: 26px;
  width: 820px;

  border-radius: 13px;
  ${layerHPA}


  ${flexBoxCenter}
`;

const Title = styled.p`
  font-size: 14px;
`;

const MainTempBox = styled.div`
  width: 817px;

  height: 200px;

  border-radius: 8px;
  ${layerHPA}


  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  align-content: space-around;
`;

const TempBoxWrapper = styled.div`
  width: 400px;
  height: 92px;
`;
